<template>
  <div>
    <div class="header">
      <div class="title_info">
        <img src="../../assets/info.png" alt="" />
        <span>待回复意见反馈{{ pendingCount }}个</span>
      </div>
      <div class="search-box">
        <el-input
          style="width:280px; margin-right:12px;"
          placeholder="搜索"
          prefix-icon="el-icon-search"
          v-model="searchValue"
          @keyup.enter.native="handleSearch"
        >
        </el-input>
        <el-date-picker
          v-model="searchDate"
          type="date"
          placeholder="请选择日期"
          style="margin-right:12px;"
        >
        </el-date-picker>
        <el-button type="primary" icon="el-icon-search" @click="handleSearch"
          >搜索</el-button
        >
        <el-button icon="el-icon-refresh-left" @click="handleReset"
          >重置</el-button
        >
      </div>
    </div>
    <el-table :data="tableData" style="width: 100%">
      <el-table-column label="编号" min-width="60" align="center">
        <template slot-scope="scope">
          <span>{{ scope.$index + 1 + (page - 1) * pageSize }}</span>
        </template>
      </el-table-column>
      <el-table-column prop="date" label="用户头像" width="80" align="center">
        <template slot-scope="scope">
          <img
            style="width: 32px;height: 32px;"
            :src="scope.row.avatarUrl"
            alt=""
          />
        </template>
      </el-table-column>
      <el-table-column
        prop="kycStatus"
        label="实名认证状态"
        width="110"
        align="center"
      >
        <template slot-scope="scope">
          <img
            style="width: 20px; height: 20px;"
            :src="
              scope.row.kycStatus == 0
                ? require('@/assets/icon/Unverified.png')
                : require('@/assets/icon/realname.png')
            "
            :alt="scope.row.kycStatus == 0 ? '未实名' : '已实名'"
          />
        </template>
      </el-table-column>
      <el-table-column prop="userId" label="用户ID" width="180">
      </el-table-column>
      <el-table-column
        prop="userName"
        label="用户名"
        width="100"
        align="center"
      >
      </el-table-column>
      <el-table-column prop="mobile" label="手机号" width="120" align="center">
      </el-table-column>
      <el-table-column
        prop="companyName"
        label="所属公司"
        width="160"
        align="center"
      >
      </el-table-column>
      <el-table-column prop="device" label="机型" width="100" align="center">
      </el-table-column>
      <el-table-column prop="appVersion" label="担当版本" width="80">
      </el-table-column>
      <el-table-column
        prop="feedbackTime"
        label="反馈时间"
        min-width="120"
        align="center"
      >
        <template slot-scope="scope">
          {{ rebuildTime(scope.row.feedbackTime) }}
        </template>
      </el-table-column>
      <el-table-column prop="title" label="标题" min-width="120" align="center">
      </el-table-column>
      <el-table-column prop="status" label="状态" width="80">
        <template slot-scope="scope">
          <span style="color: #FF8400;" v-if="scope.row.status == 0"
            >待回复</span
          >
          <span style="color: #2D6DFF;" v-if="scope.row.status == 1"
            >已回复</span
          >
        </template>
      </el-table-column>
      <el-table-column label="操作" width="100" align="center" fixed="right">
        <template slot-scope="scope">
          <el-button type="text" @click="goDetail(scope.row)"
            >查看详情</el-button
          >
        </template>
      </el-table-column>
    </el-table>
    <div class="page_line">
      <el-pagination
        background
        layout="prev, pager, next"
        :current-page.sync="page"
        :page-size="pageSize"
        @current-change="getData"
        :total="total"
      ></el-pagination>
    </div>
  </div>
</template>
<script>
import { getFeedBackList } from "@/api/index";

export default {
  data() {
    return {
      searchValue: "",
      searchDate: "",
      tableData: [],
      pendingCount: 0,
      total: 0,
      page: 1,
      pageSize: 10,
    };
  },
  mounted() {
    this.getData();
  },
  methods: {
    getData() {
      let data = {
        page: this.page,
        size: this.pageSize,
      };
      if (this.searchValue) {
        data.title = this.searchValue;
      }
      if (this.searchDate) {
        data.date = this.searchDate.getTime();
      }
      getFeedBackList(data).then((res) => {
        if (res.data.page) {
          this.tableData = res.data.page.records;
          this.total = res.data.page.total;
        } else {
          this.tableData = [];
          this.total = 0;
        }
        this.pendingCount = res.data.pendingCount;
      });
    },
    handleSearch() {
      this.page = 1;
      this.getData();
    },
    handleReset() {
      this.searchValue = "";
      this.searchDate = "";
      this.page = 1;
      this.getData();
    },
    goDetail(data) {
      this.$router.push({
        path: `/feedBackDetail`,
        query: { id: data.id },
      });
    },
    rebuildTime(time, type) {
      const now = new Date().getTime();
      const date = new Date(Number(time)),
        Y = date.getFullYear(),
        M =
          date.getMonth() + 1 < 10
            ? "0" + (date.getMonth() + 1)
            : date.getMonth() + 1,
        D = date.getDate() < 10 ? "0" + date.getDate() : date.getDate(),
        h = date.getHours() < 10 ? "0" + date.getHours() : date.getHours(),
        m =
          date.getMinutes() < 10 ? "0" + date.getMinutes() : date.getMinutes();
      const dateTimestamp = date.getTime();
      if (type == 2) {
        return String(Y).concat("/", M, "/", D);
      } else {
        return String(Y).concat("/", M, "/", D, " ", h, ":", m);
      }
    },
  },
};
</script>
<style lang="scss" scoped>
.header {
  display: flex;
  margin-bottom: 16px;
}

.search-box {
  display: flex;
  align-items: center;

  ::v-deep .el-button {
    height: 40px;
    padding: 10px 20px;
    font-size: 14px;
    border-radius: 4px;
    transition: all 0.3s;

    &.el-button--primary {
      background: #2c67ec;
      border-color: #2c67ec;

      &:hover {
        background: #4d7ef7;
        border-color: #4d7ef7;
      }

      &:active {
        background: #1f4fc9;
        border-color: #1f4fc9;
      }
    }

    &.el-button--default {
      color: #606266;
      border-color: #dcdfe6;
      background: #fff;

      &:hover {
        color: #2c67ec;
        border-color: #2c67ec;
        background: #f5f7fa;
      }

      &:active {
        color: #1f4fc9;
        border-color: #1f4fc9;
      }
    }

    & + .el-button {
      margin-left: 12px;
    }
  }
}

.title_info {
  /* 自动布局子元素 */
  position: static;
  left: 0px;
  top: 4px;
  width: 470px;
  height: 32px;
  border-radius: 6px;
  opacity: 1;

  /* 自动布局 */
  display: flex;
  align-items: center;
  flex-direction: row;
  // justify-content: space-between;
  padding: 6px 12px;
  flex-grow: 1;
  background: linear-gradient(90deg, #fff1eb 0%, rgba(255, 241, 235, 0) 100%);
  z-index: 0;
  color: #ff8400;

  img {
    width: 20px;
    height: 20px;
    margin-right: 8px;
  }
}
.page_line {
  display: flex;
  justify-content: center;
  margin: 20px 0;
}
</style>
